<script setup lang="ts">
    import { computed } from 'vue'

    const props = defineProps<{
        part: unknown
    }>()

    const emit = defineEmits<{
        select: [option: { id: string; label: string; value: string }]
    }>()

    const toolPart = computed(() => {
        return JSON.parse(JSON.stringify(props.part)) as {
            state?: string
            toolCallId?: string
            input?: {
                question: string
                options: Array<{
                    id: string
                    label: string
                    value: string
                }>
            }
            output?: {
                id: string
                label: string
                value: string
            }
        }
    })

    const toolState = computed(() => {
        return toolPart.value?.state || 'unknown'
    })

    const isInteractive = computed(() => {
        return toolState.value === 'input-available'
    })
</script>

<template>
    <div
        :key="toolState"
        class="border border-surface-3 rounded-xl w-full overflow-hidden">
        <div
            class="px-sm py-10 font-bold bg-surface-1 text-12 border-b border-surface-3 text-word-3">
            {{ toolPart.input?.question }}
        </div>
        <div v-if="toolPart.input?.options?.length" class="px-sm py-10">
            <VvButtonGroup
                :key="toolPart.input.options.length"
                modifiers="vertical"
                class="w-full">
                <VvButton
                    v-for="(option, index) in toolPart.input?.options"
                    :key="index"
                    modifiers="action-multiline"
                    class="whitespace-normal w-full"
                    :class="{
                        pressed: option.id === toolPart?.output?.id,
                    }"
                    :disabled="!isInteractive"
                    :label="option.label"
                    @click.stop="emit('select', option)" />
            </VvButtonGroup>
        </div>
    </div>
</template>
